import { SelectionModeType } from '~/modules/product';

export const MODE_PICK_PRODUCT = SelectionModeType.SINGLE;
